import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceChangePasswordNotificationState = createStateReducer(initialState, {
  [events.changePasswordSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "changePassword",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.changePasswordFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "changePassword",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceChangePasswordNotificationState };
